module.exports = __webpack_public_path__ + "img/VPS_Info_.05818b3.svg";